var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsFaceSad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:face-sad"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 50.4166C40.6565 50.4166 50.9166 40.1564 50.9166 27.4999C50.9166 14.8434 40.6565 4.58325 28 4.58325C15.3435 4.58325 5.08333 14.8434 5.08333 27.4999C5.08333 40.1564 15.3435 50.4166 28 50.4166Z",
    stroke: "#2B363B",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.8333 20.7394V20.5103M37.1666 20.7394V20.5103",
    stroke: "#2B363B",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.1666 36.6665C36.0208 33.229 33.0646 29.7915 28 29.7915C22.9354 29.7915 19.9791 33.229 18.8333 36.6665",
    stroke: "#2B363B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsFaceSad);
export default __webpack_public_path__ + "static/media/akar-icons_face-sad.470d9467bd4ed73b13b285bd29fb6f31.svg";
export { ForwardRef as ReactComponent };